import gql from 'graphql-tag';
import { sessionReportSummaryInfoScoreAggregateFieldsFragment } from './sessionReportSummaryInfoScoreAggregateFieldsFragment';

export const sessionReportSummaryInfoFieldsFragment = gql`
  fragment AdminSessionReportSummaryInfoFields on SessionReportSummaryInfo {
    perCategory {
      ...AdminSessionReportSummaryInfoScoreAggregateFields
    }
    perEvaluation {
      ...AdminSessionReportSummaryInfoScoreAggregateFields
    }
  }

  ${sessionReportSummaryInfoScoreAggregateFieldsFragment}
`;